import React from 'react';

const ProgressBar = ({ percentage }) => {
  return (
    <div className="progress-bar-container" style={containerStyles}>
      <div className="progress-bar-fill" style={{ width: `${percentage}%`, ...fillStyles }}>
      </div>
    </div>
  );
};

const containerStyles = {
  width: '100px',
  height: '5px',
  backgroundColor: '#e0e0df',
  borderRadius: '50px',
  overflow: 'hidden',
};

const fillStyles = {
  height: '100%',
  backgroundColor: '#3e9ef7',
  lineHeight: '30px',
  color: 'white',
  borderRadius: 'inherit',
  transition: 'width 0.3s ease-in-out', 
};

export default ProgressBar;
